import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { EloquaLinkedService } from 'app/model/linkedservice/eloqua.linkedservice';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from 'app/model/adapters/linkedservices/azure-key-vault.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(EloquaLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                endpoint: '*',
                username: '*',
                password: 'secret',
                useEncryptedEndpoints: '*',
                useHostVerification: '*',
                usePeerVerification: '*',
                encryptedCredential: '*'
            }
        }
    }
})
export class EloquaLinkedServiceAdapter extends LinkedServiceAdapter<EloquaLinkedService> {
    protected modelConstructor(): new () => EloquaLinkedService {
        return EloquaLinkedService;
    }

    protected model(): IModel {
        return EloquaLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: EloquaLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.EloquaLinkedService;
        properties.type = Metamodel.modelFor(EloquaLinkedService).name;

        properties.typeProperties = {
            endpoint: linkedService.endpoint,
            username: linkedService.username,
            password: passwordOrAKVtoSecretBase(linkedService.password, this.context),
            useEncryptedEndpoints: linkedService.useEncryptedEndpoints,
            useHostVerification: linkedService.useEncryptedEndpoints !== false ? linkedService.useHostVerification : undefined,
            usePeerVerification: linkedService.useEncryptedEndpoints !== false ? linkedService.usePeerVerification : undefined
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: EloquaLinkedService): Promise<EloquaLinkedService> {
        const properties = linkedServiceResource.properties as Model.EloquaLinkedService;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const typeProperties: Model.EloquaLinkedServiceTypeProperties = properties.typeProperties;

        linkedService.endpoint = typeProperties.endpoint;
        linkedService.username = typeProperties.username;
        linkedService.password = secretBaseToPasswordOrAKV(typeProperties.password, true, this.context);
        linkedService.useEncryptedEndpoints = typeProperties.useEncryptedEndpoints;
        linkedService.useHostVerification = typeProperties.useHostVerification;
        linkedService.usePeerVerification = typeProperties.usePeerVerification;

        return linkedService;
    }
}
